import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    descriptionLineOne: 'Sorry, this page is not yet available on computer.',
    descriptionLineTwo: 'To continue, go to the Shine mobile app.',
    goBackHome: 'Back to home',
    title: 'Go to the mobile app',
  },
  fr: {
    descriptionLineOne: `Désolé, cette page n'est pas encore disponible sur ordinateur.`,
    descriptionLineTwo: `Rendez-vous sur l'appli mobile Shine pour continuer.`,
    goBackHome: `Revenir à l'accueil`,
    title: 'Rendez-vous sur votre appli mobile Shine',
  },
} as const);

export default locales;
